// extracted by mini-css-extract-plugin
module.exports = {"loading-box":"Main_loading-box__1n6vZ"};